<template>
  <vx-card class="mt-base" :title="activityTitle">
    <h4 class="mb-5">Building Strong Structures with Triangles</h4>
    <p class="mb-5">
      We now know that civil engineers are responsible for designing and building some of the most
      important structures in our environment. Because of this, it’s really important that they know
      how to build <strong>strong</strong> structures.
    </p>
    <p class="mb-5">
      Watch the following video to learn more about which shapes help to strengthen structures and
      which do not!
    </p>
    <responsive-youtube-wrapper :video="videos[1].video" :image="videos[1].image" />
    <p class="mb-5">
      In this video, we learnt the importance of triangles for building strong structures.
    </p>
    <centered-image-wrapper
      :image="require('@/assets/images/experiences/engineering/triangle_power.jpg')"
      alt="Triangle Power! A triangle with the words Support, Stiffen and Stabilise at its three corners."
    />

    <h4 class="mb-5">Harness The Power of the Tetrahedron!</h4>
    <p class="mb-5">
      In the video, you saw the presenter building triangles using toothpicks and connectors made
      from gummy worms. Notice how he connects 4 triangles together to form a tetrahedron and then
      joins lots of tetrahedrons together to create a structure strong enough to hold up a brick (or
      other heavy object).
    </p>
    <p class="mb-5">Now, it’s your turn!</p>
    <h4 class="mb-5"><u>Your Task:</u></h4>
    <p class="mb-5">
      Create a structure that will hold a brick (or similar heavy object) at least 10cm off the
      ground.
    </p>
    <p class="mb-5">You Will Need:</p>
    <ul class="default-list mb-5">
      <li>Toothpicks</li>
      <li>Gummy worms</li>
      <li>Scissors</li>
      <li>A brick (or other heavy object)</li>
    </ul>
    <p class="mb-5">
      Try experimenting with different numbers of tetrahedrons and objects of different weights.
    </p>
    <p class="mb-5">Take a photo of your creation and upload it here.</p>
    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_1']"
      :is-editable="isEditable"
      :upload-btn-text="'Upload Your Photo'"
      filetype="photo_doc"
      class="mb-5"
      index="1"
    />
    <h4 class="mb-5">Bonus Activity: Can you build a stool?</h4>
    <p class="mb-5">
      Watch the video again and see how the presenter builds a stool using nothing but empty cans,
      paint sticks, and duct tape. Notice how he uses triangles to reinforce the stability and
      stiffness of his structure. Can you build a stool tool too? What other objects can you create
      with these materials?
    </p>
    <p class="mb-5">Take some photos of your creations and upload them here.</p>
    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_2']"
      :is-editable="isEditable"
      :upload-btn-text="'Upload Your Photo'"
      filetype="photo_doc"
      class="mb-5"
      index="2"
    />
    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_3']"
      :is-editable="isEditable"
      :upload-btn-text="'Upload Your Photo'"
      filetype="photo_doc"
      class="mb-5"
      index="3"
    />

    <h4 class="mb-5">Review</h4>
    <p class="mb-5">
      Anytime you need to <strong>support</strong>, <strong>stiffen</strong>, or
      <strong>stabilise</strong> a structure, be sure to add a triangle. The next time you’re out
      and about, look around at the various structures and see how many triangles you can spot that
      were used in their construction.
    </p>

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      videos: {
        1: {
          image: require('@/assets/images/experiences/engineering/triangles.jpg'),
          video: 'https://www.youtube.com/embed/mBHJtWbsiaA',
        },
      },
      image1: require('@/assets/images/experiences/gamesdeveloper/activity_1_1.png'),
      uploaded_files: {
        uploaded_file_1: '',
        uploaded_file_2: '',
        uploaded_file_3: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    for (let i = 1; i <= 4; i++) {
      if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
        this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
      }
    }
  },
};
</script>
